<template>
  <Loader />
</template>

<script>
import Loader from "@/components/Loader.vue";
import { handleCallback } from '@/services/oidc.service';

export default {
  name: "callback",
  components: {
    Loader,
  },
  async mounted() {
    try {
      const user = await handleCallback();  // Automatically processes the OIDC callback
      localStorage.setItem("token", user.access_token);
      this.$router.push('/');  // Redirect to the protected route after successful login
    } catch (error) {
      console.error('Error during callback:', error);
    }
  }
};
</script>